// extracted by mini-css-extract-plugin
export var brand = "_9y-9";
export var compact = "_9y-6";
export var extraSmall = "_9y-7";
export var icon = "_9y-0";
export var large = "_9y-4";
export var light = "_9y-1";
export var medium = "_9y-5";
export var outline = "_9y-b";
export var primaryDark = "_9y-a";
export var primaryLight = "_9y-8";
export var primaryModern = "_9y-c";
export var success = "_9y-2";
export var successSolid = "_9y-3";